import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { AISummary } from "../../ai_summary";

export function useRegenerateDatasetSummary() {
  const { datasetService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<AISummary, Error, { datasetId: string }>({
    mutationFn: ({ datasetId }) => {
      return datasetService.generateSummary(datasetId);
    },
    onSuccess: (newSummary, { datasetId }) => {
      queryClient.setQueryData(["dataset-summary", datasetId], newSummary);
    },
  });
}
